App.prototype.checkBoxChanged = function (unique_id) {
    var object = $("input[name='features[" + unique_id + "][]']");
    var anyCheckedOption = false;
    object.each(function () {
        if (this.checked) {
            anyCheckedOption = true;
        }
    });
    if (anyCheckedOption) {
        object.removeAttr('required');
    } else {
        object.attr('required', 'required');
    }
};

App.prototype.buildCheckbox = function (data, targetElement) {
    var options = '';
    var required = data.is_required ? ' required' : '';
    data.options.forEach(function (item) {
        var additionalPrice = item.price > 0 ? ` (+${item.price} ${translates.currency_code})` : '';
        options +=
            `<div class="custom-control custom-checkbox mb-2">
                <input type="checkbox"
                name="features[${data.unique_id}][]"
                class="custom-control-input"
                id="${item.unique_id}"
                value="${item.unique_id}"
                ${required}>
                <label class="custom-control-label" for="${item.unique_id}">${item.name}${additionalPrice}</label>
            </div>`;
    });
    var is_required = data.is_required ? `<span class="badge badge-danger">1 ${translates.required}</span>` : '';
    var expander =
        data.options.length > 5 ?
            `<button type="button" class="feature-expander">
                <i class="ksicon chevron-down"></i>
                ${data.options.length - 5} ${translates.see_options}
            </button>` :
            '';
    var select =
        `<div class="form-group">
            <label class="d-flex align-items-center justify-content-between">
                <h6 class="mb-0">${data.name}</h6>
                ${is_required}
            </label>
            ${options}
            ${expander}
        </div>`;
    targetElement.append(select);
};

document.addEventListener('click', function (ev) {
    if (ev.target.classList.contains('feature-expander')) {
        const maxDepth = 5;
        let currentDepth = 0;
        let featureSelectionsParent = ev.target.parentElement;
        while(featureSelectionsParent.classList.contains('feature-selections') === false && currentDepth < maxDepth){
            featureSelectionsParent = featureSelectionsParent.parentElement;
            currentDepth++;
        }
        featureSelectionsParent.classList.add('expanded');
    }
})
